export const DEFAULT_CUSTOM_AMOUNT_MAX = 1000;

const roundAmount = (value) => Math.round(Number(value) * 100) / 100;

export const isCustomPricedProduct = (product) =>
    product?.is_voucher === true || product?.custom_pricing_enabled === true;

export const getMinimumCustomAmount = (product) => {
    if (!product) {
        return 1;
    }

    if (product.is_voucher) {
        return roundAmount(product.voucher_min_amount || 1);
    }

    return roundAmount(product.custom_amount_min ?? product.price ?? 1);
};

export const getMaximumCustomAmount = (product) => {
    if (!product) {
        return DEFAULT_CUSTOM_AMOUNT_MAX;
    }

    if (product.is_voucher) {
        return roundAmount(product.voucher_max_amount || DEFAULT_CUSTOM_AMOUNT_MAX);
    }

    return roundAmount(product.custom_amount_max ?? DEFAULT_CUSTOM_AMOUNT_MAX);
};

export const getInitialCustomAmount = (product) => {
    const minAmount = getMinimumCustomAmount(product);
    const maxAmount = getMaximumCustomAmount(product);
    const initialAmount = roundAmount(product?.price ?? minAmount);

    return Math.min(Math.max(initialAmount, minAmount), maxAmount);
};
